import { FormData } from "@/interface/profile";
import { useState } from "react";

export const useProfile = ({ user }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [profileData, setProfileData] = useState<FormData>({
    name: user?.name || "Nama Pengguna",
    email: user?.email || "email@address.com",
    phone: user?.phone || "",
  });
  const [formData, setFormData] = useState<FormData>({ ...profileData });
  const [showToast, setShowToast] = useState(false);

  const avatarUrl = (name: string) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "User")}&background=2d2d2d&color=fff&size=128`;

  const openModal = () => {
    setFormData({ ...profileData });
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = () => {
    setProfileData({ ...formData });
    closeModal();
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2500);
  };

  return {
    isModalOpen,
    showToast,
    profileData,
    formData,
    closeModal,
    avatarUrl,
    openModal,
    handleChange,
    handleSave,
  };
};
